import React from 'react';
import { Link } from 'react-router-dom';
import styles from './Products.module.css';

function Products() {
  return (
    <section className={styles.section} id="products">
      <div className={styles.container}>
        <h2 className={styles.title}>Our Product</h2>
        <p className={styles.subtitle}>A brief overview of what we offer</p>

        <div className={styles.grid}>
          <article className={styles.card}>
            <div className={styles.cardHeader}>
              <h3 className={styles.cardTitle}>OpsAssist</h3>
              <span className={styles.badge}>Trusted by SATS</span>
            </div>
            <div className={styles.cardContent}>
              <p className={styles.description}>
                OpsAssist is an AI-powered ground operations assistant designed to streamline airport workflows. It automates task assignments, optimizes driver scheduling, and gives real-time visibility into operations—helping airports reduce manual effort and improve efficiency.
              </p>
              <ul className={styles.features}>
                <li className={styles.feature}>
                  <span className={styles.arrowIcon}>→</span>
                  Automates task assignments and driver scheduling
                </li>
                <li className={styles.feature}>
                  <span className={styles.arrowIcon}>→</span>
                  Provides real-time operational insights
                </li>
                <li className={styles.feature}>
                  <span className={styles.arrowIcon}>→</span>
                  Reduces manual workload and boosts efficiency
                </li>
              </ul>
            </div>
            <div className={styles.buttonRow}>
              <Link to="/ops-assist" className={styles.button}>Know More</Link>
            </div>
          </article>

          <div className={styles.videoCard}>
            <div className={styles.videoEmbed}>
              <iframe
                width="100%"
                height="315"
                src="https://www.youtube.com/embed/6Q_jtegoDZc"
                title="OpsAssist Demo Video"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowFullScreen
              ></iframe>
              <div className={styles.videoTitle}>
                Future of Airport Operations
                <br />
                <small>Watch how AI transforms airport operations</small>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}

export default Products;


